import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import './ConfirmDeleteModal.scss';
import Button from '../Button/Button';

const ConfirmationModal = ({ id, isOpen, handleClose, handleDelete, header, message }) => {
    return (
        <>
            {isOpen &&
                <Modal id={id} isOpen={isOpen} handleClose={handleClose} size="x-sm">
                    <div className='confirm-modal'>
                        <h2>{header}</h2>
                        <p>{message}</p>
                        <div className = 'button-container'>
                            <Button id={`${id}-close-btn`} className='btn--rounded btn--blue-white btn--close'
                                onClick={() => handleClose()}
                            >
                                Cancel
                            </Button>
                            <Button id={`${id}-delete-btn`} className='btn--rounded btn--blue-light btn--delete'
                                onClick={() => handleDelete()}
                            >
                                Yes, remove it
                            </Button>
                        </div>
                        
                    </div>
                </Modal>
            }
        </>
    )
}

ConfirmationModal.propTypes = {
    id: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    header: PropTypes.string,
    message: PropTypes.string
}

export default ConfirmationModal;